import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/contacts')({
  component: ContactsPage,
});

function ContactsPage() {
  return <div className="placeholder">Contacts — Coming Soon</div>;
}
